import React from "react";

import Box from "@mui/material/Box";

import checkIcon from "../../assets/icons/check.png";

const CheckIcon = ({ onClick, sx }) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				padding: "4px",
				border: "1px solid rgba(224, 224, 224, 1)",
				borderRadius: "4px",
				cursor: "pointer",
				height: "27px",
				width: "27px",
				...sx,
			}}
			onClick={onClick}
		>
			<img
				src={checkIcon}
				alt="delete"
				style={{ width: "100%", height: "100%", objectFit: "contain" }}
			/>
		</Box>
	);
};

export default CheckIcon;
